import { getOrderProcurementItems } from '../../../HttpRequests/orderProcurement';
import { setProcurementItems } from '../State/procurementItems';

export default (orderId) => (dispatch) => {
    return getOrderProcurementItems(orderId)
        .then(response => {
            const items = response.data.data || [];
            dispatch(setProcurementItems(items));
        })
        .catch(error => {
            console.error('Failed to fetch procurement items:', error);
            // Silently fail - procurement items are optional
            dispatch(setProcurementItems([]));
        });
}
